import { List } from 'immutable';
import { investorConstants } from '../constants';
import { sortByAsc } from 'views/helpers';

export function investors(state = {}, action) {
  switch (action.type) {
    case investorConstants.INVESTOR_LIST_LOADING:
      return {
        ...state,
        listLoading: true
      };
    case investorConstants.INVESTOR_LIST_SUCCESS:
      return {
        ...state,
        items: List(action.response),
        listLoading: false
      };
    case investorConstants.INVESTOR_LIST_FAILURE:
      return {
        ...state,
        listLoading: false,
        items: [],
        listError: action.error
      };
    case investorConstants.INVESTOR_CREATE_LOADING:
      return {
        ...state,
        createLoading: true
      };
    case investorConstants.INVESTOR_CREATE_SUCCESS: {
      const items = state.items ? state.items : List();
      return {
        ...state,
        items: sortByAsc(items.push(action.response), 'name'),
        createLoading: false,
        createError: null
      };
    }

    case investorConstants.INVESTOR_CREATE_FAILURE:
      return {
        ...state,
        createLoading: false,
        createError: action.error
      };

    case investorConstants.INVESTOR_EDIT_LOADING:
      return {
        ...state,
        editLoading: true
      };
    case investorConstants.INVESTOR_EDIT_SUCCESS: {
      if (!state.items) {
        return state;
      }

      const investorIndex = state.items.findIndex(val => val.id == action.response.id);

      if (investorIndex == -1) {
        return state;
      }

      return {
        ...state,
        items: state.items.set(investorIndex, action.response),
        editLoading: false,
        editError: null
      };
    }
    case investorConstants.INVESTOR_EDIT_FAILURE:
      return {
        ...state,
        editLoading: false,
        editError: action.error
      };

    case investorConstants.INVESTOR_DELETE_LOADING:
      return {
        ...state,
        deleteLoading: true
      };
    case investorConstants.INVESTOR_DELETE_SUCCESS: {
      const { investorId } = action;

      if (!state.items) {
        return state;
      }

      const investorIndex = state.items.findIndex(val => val.id == investorId);

      if (investorIndex == -1) {
        return state;
      }

      return {
        ...state,
        items: state.items.delete(investorIndex),
        deleteLoading: false,
        deleteError: null
      };
    }
    case investorConstants.INVESTOR_DELETE_FAILURE:
      return {
        ...state,
        deleteLoading: false,
        deleteError: action.error
      };
    case investorConstants.INVESTOR_ERROR_RELOAD:
      return {
        ...state,
        createError: null,
        editError: null
      };

    default:
      return state;
  }
}
